import Link from "next/link";

import { routes } from "src/shared/routes";
import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I claim my tickets?",
    answer:
      "You will receive a text when the window to check in is opened. The check in window starts at 9:00 AM the day before the homestand begins. After checking in you will have the opportunity to purchase guest tickets & upgrades if they are available.",
  },
  {
    question: "Do I get a ticket to each game on the schedule?",
    answer:
      "Tickets are guaranteed for the games defined in the pass. There are no penalties for not attending a game, however you do need to confirm your attendance in order to receive a ticket. Please note that your League One Volleyball Madison Pass only guarantees you tickets to games you have checked in for.",
  },
  {
    question: "How are tickets sent to me?",
    answer:
      "3 hours prior to game start you will receive a text confirming that tickets have been delivered to your account.",
  },
  {
    question: "Where will my seats be located?",
    answer: "Seats will be throughout the arena and mostly in the upper bowl.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "Yes, the Passes are non-transferable, but can be assigned to others in your party to enter separately.",
  },
  {
    question: "Can my seats be changed?",
    answer: (
      <>
        Once tickets have been sent to your account, they cannot be changed.
        Please contact{" "}
        <a href="mailto:ticketing@lovb.com">ticketing@lovb.com</a> for any
        assistance you may require.
      </>
    ),
  },
  {
    question: "Can I link tickets with other pass holders?",
    answer: (
      <>
        You can absolutely create a group to link with other pass holders!
        Navigate to the{" "}
        <Link
          href={{
            pathname: routes.my_group,
            query: { teamSchema: "lovb_madison" },
          }}
        >
          My Group
        </Link>{" "}
        tab in your menu and copy the invite. This will ensure you are seated
        next to or close enough to hand a drink to one another for the game. You
        will need to ensure your group is created and all members have joined at
        least 4 hours prior to game start in order to be seated with one
        another.
      </>
    ),
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },
];

export const REGISTER_TERMS_AND_CONDITION = () => (
  <>
    By checking this box you agree to receive notifications and offers from
    League One Volleyball and to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);

export const TERMS_AND_CONDITION = () => (
  <>
    By checking this box you agree to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);
